import React from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";

const ResumeCard = ({ resume }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // resume.thumbnail is a Base64 JPEG (or URL) saved from the resume preview.
  const hasThumbnail = Boolean(resume.thumbnail);

  return (
    <div className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-xl border border-white/10 bg-[#0b0e14]/60 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-cyan-500/40 hover:shadow-[0_10px_30px_-15px_rgba(6,182,212,0.45)]">
      {/* Letter-proportioned (8.5 x 11) page preview, scaled to the card width */}
      <div className="aspect-[8.5/11] w-full overflow-hidden border-b border-white/10 bg-white">
        {hasThumbnail ? (
          <img
            src={resume.thumbnail}
            alt={resume.resume_name}
            className="h-full w-full object-contain object-top"
          />
        ) : (
          <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-neutral-100 text-neutral-400">
            <DocumentTextIcon className="h-10 w-10" />
            <span className="text-xs font-medium">No preview yet</span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-white transition-colors group-hover:text-cyan-300">{resume.resume_name}</h3>
        <p className="mt-0.5 text-xs text-neutral-500">Edited {formatDate(resume.last_edited)}</p>
      </div>
    </div>
  );
};

export default ResumeCard;
